import getAppState from 'app-state';
import { PopupData } from '../types';

const getCurrentPopup = () =>
    getAppState<PopupData>('pwsHomePagePopups.currentPopup', null);

export default getCurrentPopup;
